export enum RouletteFrenchCombo {
    TIER = 'tier',
    ORPHELINS = 'orphelins',
    VOISINS = 'voisins',
    ZERO = 'zeroFrench',
}
